module.exports = __webpack_public_path__ + "card-DC.png?b93df58152b26666d1b47b1c3db15c40";